import { Container } from '@/components'
import { Banner, TemplateItem, Wrapper } from '@/components/templates'
import { TEMPLATE_CATEGORY_DESCRIPTIONS } from '@/constants/template'
import { TemplateService, TemplatesResult } from '@/service'
import { slugifyText, unique } from '@/utils/helper'

interface TemplatesCategoryPageProps {
  categories: string[]
  selected: {
    slug: string
    name: string
  }
  templates: TemplatesResult[]
}

const TemplatesCategoryPage = ({
  categories,
  selected,
  templates
}: TemplatesCategoryPageProps): JSX.Element => (
  <Container
    headerBackground="#fff"
    url={`/templates/category/${encodeURIComponent(selected.slug)}`}
    title={`${selected.name} | Templates | HeyForm`}
    description={
      TEMPLATE_CATEGORY_DESCRIPTIONS[selected.name] ||
      `Browse customizable ${selected.name.toLowerCase()} templates for HeyForm.`
    }
  >
    <main>
      <Banner
        title={`${selected.name} templates`}
        description={`Find a starting point for your next ${selected.name.toLowerCase()} form. Preview a template, then customize it for your needs.`}
      />
      <Wrapper categories={categories} selectedCategory={selected.name}>
        <TemplateItem
          heading={`${selected.name} templates`}
          templates={templates}
        />
      </Wrapper>
    </main>
  </Container>
)

export async function getServerSideProps({
  params
}: NextContext): Promise<unknown> {
  const slug = params.category as string
  const result = await TemplateService.list()

  const categories = unique(result.map(row => row.Category).flat())
  const templates = result.filter(row => {
    return row.Category.map(c => slugifyText(c)).includes(slug)
  })

  const categoryName = categories.find(c => slugifyText(c) === slug)
  if (!categoryName) return { notFound: true }

  return {
    props: {
      categories,
      selected: {
        slug,
        name: categoryName
      },
      templates
    }
  }
}

export default TemplatesCategoryPage
